export default __webpack_public_path__ + "static/media/FileaDispute.b31b783f.svg";